import * as React from 'react';

import { StatusChip } from '@/design';
import type { IRankingFlag } from '../api/ranking-process-contracts';

/** What a list's criteria flag in a placement (SR-506): a chip each, its sentence on hover and to a
 *  screen reader — unless `said`, where the caller draws the sentence beside it. Nothing for none. */
export function RankingFlags({ flags, said = false }: { flags?: IRankingFlag[]; said?: boolean }) {
  if (!flags || flags.length === 0) return null;
  return (
    <span className="mt-1 flex flex-wrap gap-1" data-flags>
      {flags.map((flag) => (
        <span key={flag.code} data-flag={flag.code} title={flag.message}>
          <StatusChip tone="attention">
            {flag.label}
            {!said && <span className="sr-only">: {flag.message}</span>}
          </StatusChip>
        </span>
      ))}
    </span>
  );
}
